import { TranslateService } from "@ngx-translate/core";
var NoteDataComponent = /** @class */ (function () {
    function NoteDataComponent(translate) {
        this.translate = translate;
    }
    return NoteDataComponent;
}());
export { NoteDataComponent };
